import React from "react";
import styles from "../ConnectedChannel/ConnectedChannel.module.css";
import Icon from "../../../Icon";
import { channelErrors } from "../ConnectedChannel/ConnectedChannel.data";
import { ChannelError } from "../../../../features/api/apiSlice";
import { ChannelErrorMessageProps } from "./ChannelErrorMessage.interface";

const ChannelErrorMessage: React.FC<ChannelErrorMessageProps> = ({
  error,
  platform,
  onUpdateToken,
  onDelete
}) => {
  const renderActionButton = () => {
    switch (error) {
      case ChannelError.TOKEN_AUTH_ERROR:
        return (
          <button
            className={styles["channel_refresh-button"]}
            onClick={() => onUpdateToken?.(platform)}
          >
            <Icon name="refresh" />
            Обновить токен
          </button>
        );

      case ChannelError.UNSUPPORTED_PLATFORM:
        return (
          <button
            className={styles["channel_refresh-button"]}
            onClick={onDelete}
          >
            <Icon name="trash-bin" />
            Удалить
          </button>
        );

      default:
        return null;
    }
  };

  return (
    <div className={styles.channel__error}>
      <Icon name="channel-error" />
      <p className={styles.channel__errorText}>{channelErrors[error]}</p>
      {renderActionButton()}
    </div>
  );
};

export default ChannelErrorMessage;
